import clsx from "clsx";

const baseStyles = {
  classes: "mb-6 text-xl font-bold text-pri md:mb-10 md:text-2xl",
};

export function TermHead({ variant = "classes", className, ...props }) {
  return <h2 className={clsx(baseStyles[variant], className)} {...props}></h2>;
}
